import ErrorTemplate from './_template.js'
import template from './404.pug'

export default Vue.extend({
  template: template(),
  components: {ErrorTemplate}
})
